import { Base } from "ui/Scripts/source/framework/base";
import { infiniteListPageSize } from "../common/webConsts";
import { IModifiedRecordListItem, ModifiedRecordListItem } from "./modifiedRecordListItem";

export interface IModifiedRecordListItems {
    items: IModifiedRecordListItem[];
    hasMore: boolean;
    page: number;
    //For preloaded data
    pageSize: number;
    sortColumn: string;
    sortOrderIsAsc: boolean;
}

export class ModifiedRecordListItems implements IModifiedRecordListItems {
    items: ModifiedRecordListItem[];
    hasMore: boolean;
    page: number;
    //For preloaded data
    pageSize: number;
    sortColumn: string;
    sortOrderIsAsc: boolean;

    constructor();
    constructor(obj: IModifiedRecordListItems);
    constructor(obj?: any) {
        this.hasMore = obj && obj.hasMore || false;
        this.page = obj && obj.page || 1;
        this.pageSize = obj && obj.pageSize || infiniteListPageSize;
        this.sortColumn = obj && obj.sortColumn || "";
        this.sortOrderIsAsc = obj && obj.sortOrderIsAsc || true;
        this.items = Base.getTypedArray(obj ? obj.items : null, ModifiedRecordListItem);
    }
}